import { Input } from '@/widgets/components/input';
import { InvisibleButton } from '@/widgets/components/invisible-button';
import loginBackground from '@/../img/login-landing-background.webp';
import RentalscapeLogo from '@/../img/rentalscape-logo.svg';
import { cssVars } from '@/app/styles';
import styled from 'styled-components';

// auth-form components
export const Wrapper = styled.div`
  position: absolute;
  top: 168px;
  left: 267px;
`;

export const RentalscapeTitle = styled.div`
  color: ${cssVars.color.rentalscapeBlue};
  width: 580px;
  font-size: 95px;
  font-weight: 600;
  letter-spacing: 4px;
  line-height: 1;
  margin-bottom: 23px;

  ::before {
    content: 'rentalscape';
  }
`;

export const InputWrapper = styled.div`
  display: flex;
`;

export const StyledInput = styled(Input)`
  width: 320px;
  padding-right: 0px;

  ::placeholder {
    /* font-family: 'Nunito Sans', sans-serif; */
  }
`;

export const StyledButton = styled(InvisibleButton)`
  display: flex;
  margin-left: 23px;
  padding-left: 0px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.1; /* prettier alignment with between text and icon */
  align-items: flex-end;
  color: ${(props) =>
    props.disabled
      ? cssVars.color.buttonDisabled
      : cssVars.color.rentalscapeBlue};

  span:first-child {
    margin-right: 3px;
  }
`;

// login page components
export const LoginPageBackground = styled.div`
  /* fallback incase linear gradient is not supported */
  background-image: url(${loginBackground});
  background-image: url(${loginBackground}),
    linear-gradient(rgba(89, 126, 247, 0.4), rgba(0, 39, 102, 0.5));
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center center;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledRentalscapeLogo = styled(RentalscapeLogo)`
  width: 42px;
  height: 35px;
  position: absolute;
  top: 28px;
  left: 28px;
`;

export const SubSection = styled.div`
  margin-top: 10px;
  line-height: 1;
  letter-spacing: normal;
  display: flex;
  align-items: baseline;

  ${InvisibleButton} {
    text-decoration: underline;
    color: rgba(16, 25, 56, 0.4);
  }
`;

export const HorizontalSeparator = styled.div`
  ::before {
    content: '·';
  }
  align-self: baseline;
  padding-left: 1px;
  padding-right: 1px;
`;
